/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'disc': {
    width: 1000,
    height: 1000,
    viewBox: '0 0 1000 1000',
    data: '<path pid="0" d="M500 393.3c-58.8 0-106.7 47.9-106.7 106.7S441.2 606.7 500 606.7c58.8 0 106.7-47.9 106.7-106.7S558.8 393.3 500 393.3zm0 161.4c-30.2 0-54.7-24.5-54.7-54.7 0-30.2 24.5-54.7 54.7-54.7 30.2 0 54.7 24.5 54.7 54.7 0 30.2-24.5 54.7-54.7 54.7zm315.3-358.1c-24.9-25.9-53-48.7-83.6-67.8-67.2-42-146.6-66.3-231.7-66.3C258.3 62.5 62.5 258.3 62.5 500S258.3 937.5 500 937.5 937.5 741.7 937.5 500c0-117.8-46.5-224.7-122.2-303.4zM500 650.9c-83.2 0-150.9-67.7-150.9-150.9S416.8 349.1 500 349.1 650.9 416.8 650.9 500 583.2 650.9 500 650.9z"/>'
  }
})
